import { useTranslation } from 'react-i18next'

import { ScrollableTabs, Text } from '@reveni-io/reveni-ui'

import useTabsSearchParam from '@/configuration/pages/ConfigurationPage/hooks/useTabsSearchParam/useTabsSearchParam'

import DigitalProductTab from './DigitalProductTab/DigitalProductTab'
import WidgetAndPopupTab from './WidgetAndPopupTab/WidgetAndPopupTab'
import { returnProtectionAppearanceTabList, returnProtectionAppearanceTabs } from './constants'
import * as Styles from './styles'

const ReturnProtectionAppearanceConfiguration = () => {
  const { t } = useTranslation()

  const tabs = returnProtectionAppearanceTabList.map(tab => ({ ...tab, label: t(tab.label) }))

  const { activeTab, onChangeTab } = useTabsSearchParam({
    tabs,
    defaultTab: returnProtectionAppearanceTabs.digitalProduct,
  })

  return (
    <Styles.Container>
      <Text type="bodyMRegular">
        {t('Configura cómo se ve Return Protection para tus clientes y dónde está disponible en tu tienda.')}
      </Text>
      <ScrollableTabs tabs={tabs} value={activeTab} onChange={onChangeTab} />
      {activeTab === returnProtectionAppearanceTabs.digitalProduct && <DigitalProductTab />}
      {activeTab === returnProtectionAppearanceTabs.widgetAndPopup && <WidgetAndPopupTab />}
    </Styles.Container>
  )
}

export default ReturnProtectionAppearanceConfiguration
